import { Settings } from '@mui/icons-material'

const operationsIndex = {
  icon: Settings,
}

export default operationsIndex
